import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Play, Pause, Square } from "lucide-react";
import { useAlerts } from "@/context/AlertsContext";

const fmt = (s) => {
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
};

// Schwebende Timer-Anzeige, sichtbar solange ein Timer läuft/pausiert ist.
export const FloatingTimer = () => {
  const { remaining, running, duration, timerLabel, pauseTimer, resumeTimer, resetTimer } = useAlerts();
  const active = running || remaining < duration;

  return (
    <AnimatePresence>
      {active && (
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          className="fixed bottom-5 left-5 z-40 flex items-center gap-3 rounded-2xl border border-border bg-card px-4 py-3 shadow-xl"
          data-testid="floating-timer"
        >
          <div className="leading-tight">
            <div className="font-heading text-xl font-bold tabular-nums" data-testid="floating-timer-value">
              {fmt(remaining)}
            </div>
            {timerLabel && <div className="text-xs text-muted-foreground max-w-[120px] truncate">{timerLabel}</div>}
          </div>
          <div className="flex items-center gap-1">
            {running ? (
              <button
                data-testid="floating-timer-pause"
                onClick={pauseTimer}
                className="w-8 h-8 flex items-center justify-center rounded-lg text-muted-foreground hover:bg-secondary"
              >
                <Pause className="w-4 h-4" />
              </button>
            ) : (
              <button
                data-testid="floating-timer-resume"
                onClick={resumeTimer}
                className="w-8 h-8 flex items-center justify-center rounded-lg text-primary hover:bg-secondary"
              >
                <Play className="w-4 h-4" />
              </button>
            )}
            <button
              data-testid="floating-timer-stop"
              onClick={resetTimer}
              className="w-8 h-8 flex items-center justify-center rounded-lg text-destructive hover:bg-destructive/10"
            >
              <Square className="w-4 h-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
